/**
 * Dev Mail - Random Command
 * Get a random account address from the user's list
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface RandomOptions {
    json?: boolean;
}

async function handleRandom(options: RandomOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    const api = new TempMailApiService(config);
    const result = await api.getRandomAccount();

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    if (options.json) {
        console.log(JSON.stringify({ success: true, data: result.data }));
        return;
    }

    console.log(chalk.cyan(result.data!.address));
}

export function createMailRandomCommand(): Command {
    return new Command('random')
        .description('Lấy ngẫu nhiên 1 địa chỉ email từ danh sách')
        .option('-j, --json', 'Output dạng JSON')
        .addHelpText('after', `
Examples:
  $ j dev mail random
  $ j dev mail random -j
  $ ADDRESS=$(j dev mail random) && echo "Using: $ADDRESS"
`)
        .action(async (options: RandomOptions) => {
            await handleRandom(options);
        });
}
